module.exports = __webpack_public_path__ + "img/zx1.937272d5.png";